import { Button } from "pepsico-ds";
import React from "react";

const ActionCellRender = (props) => {
    const { buttons = [], openModal, openViewModal, data } = props;

    const handleAction = (type) => {
        if (type === 'View') {
            props.openViewModal(type, props.data, 'single');
        } else if( type === 'Approve' || type === 'Reject') {
            props.openModal(type, props.data, 'single', 'LIST');
        }
        else if(type === 'select') {
            props.onSelectUser(props.data);
        }
    };

    return (
        <div className="d-flex justify-content-between align-items-center gap-2 h-100">
            {buttons.map((btn, index) => (
                <Button
                    key={index}
                    size="small"
                    text={btn.text}
                    variant={btn.variant}
                    disabled={data?.isDisabled}
                    onClick={() => handleAction(btn.action)}
                />
            ))}
            {/* <Button
                size="small"
                text="Approve"
                variant="primary"
                disabled={props?.data?.isDisabled}
                onClick={() => handleAction("Approve")}
            />
            <Button
                size="small"
                text="Reject"
                variant="danger"
                disabled={props?.data?.isDisabled}
                onClick={() => handleAction("Reject")}
            />
            <Button
                size="small"
                text="View More"
                variant="auxiliary"
                onClick={() => handleAction("View")}
            /> */}
        </div>
    );
}
export default ActionCellRender;